import "./css/IntroPage.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faChevronLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from "react";
import ReactDOM from 'react-dom';
import { bannerSlides } from "./bannerSlides";
import Home from "./Home";
import flyerImage from './img/flyer-Advt-draft.jpg'
import "./css/corporatesummary.css"
import tiaraCurve from "./img/corporatesummary5.png"
import Servicenowbrand from './img/snlogo-new1.png';
import { useNavigate, useLocation } from "react-router-dom";
import AnnouncementBar from "./Announcement/AnnouncementBar";
const Banner = () => {
  const [isPaused] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const runAutoInterval = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (location.state?.resetBanner) {
      setCurrentIndex(0);
    }
  }, [location]);
  const totalSlides = bannerSlides.length;


  const FullViewFlyer = ({ flyerImage }) => {
    const [isOpen, setIsOpen] = useState(false);

    const ModalPortal = () => {
      return ReactDOM.createPortal(
        <div className="system-wide-overlay" onClick={() => setIsOpen(false)}>
          <div className="system-wide-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-system-view" onClick={() => setIsOpen(false)}>&times;</button>
            <img src={flyerImage} alt="flyer image" className="full-browser-img" />
            <a href={flyerImage} download="Tiara_Flyer_HD.jpg" className="system-download-btn">
              <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" style={{ marginRight: '10px' }}>
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" />
              </svg>
              View & Download
            </a>
          </div>
        </div>,
        document.body
      );
    };

    return (
      <div className='row align-center' style={{ justifyContent: "center" }}>
        <div className="flyer-ui-card">
          <div className="flyer-img-wrapper" onClick={() => setIsOpen(true)}>
          </div>

          {/* BUTTON WITH ICON */}
          <button className="flyer-action-bar" onClick={() => setIsOpen(true)}>
            <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" strokeWidth="2.5" fill="none">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
          </button>

          {isOpen && <ModalPortal />}
        </div></div>
    );
  };

  const HandleWhatsNew = () => {
    navigate('/sntraining');
  };

  // useEffect(() => {
  //   const timeAutoNext = 7000;

  //   function startAutoPlay() {
  //     clearInterval(runAutoInterval.current);
  //     runAutoInterval.current = setInterval(() => {
  //       handleSlideChange("next");
  //     }, timeAutoNext);
  //   }

  //   function stopAutoPlay() {
  //     clearInterval(runAutoInterval.current);
  //   }

  //   if (!isPaused) startAutoPlay();
  //   else stopAutoPlay();

  //   return () => stopAutoPlay();
  // }, [isPaused, currentIndex]);

  const handleSlideChange = (direction) => {
    setCurrentIndex((prev) =>
      direction === "next"
        ? (prev + 1) % totalSlides
        : (prev - 1 + totalSlides) % totalSlides
    );
  };

  const [isOpen, setIsOpen] = useState(false);


  const handleTileClick = (index) => {
    setCurrentIndex(index);
  };

  return (
    <>
  
      {/* <a href="/snconfirmation" className="sn-emblem">
        <img src={Servicenowbrand} alt="ServiceNow Training Registration" />
      </a> */}
      {/* <button 
  className="corporate-summary-fab" 
  onClick={() => setIsOpen(true)}
>
  
  <svg 
    viewBox="0 0 24 24" 
    width="20" 
    height="20" 
    stroke="currentColor" 
    strokeWidth="2.5" 
    fill="none" 
    style={{marginRight: '10px'}}
  >
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <line x1="10" y1="9" x2="8" y2="9" />
  </svg>
    <span className="notification-badge">1</span>

  <span>Corporate Summary</span>
</button>  */}




      {/* <button 
  className="corporate-summary-chat-btn" 
  onClick={() => setIsOpen(true)}
  aria-label="Corporate Summary"
>
  <span className="notification-badge">1</span>
  
  <svg viewBox="0 0 24 24" width="28" height="28" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
    <polyline points="14 2 14 8 20 8"></polyline>
    <line x1="16" y1="13" x2="8" y2="13"></line>
    <line x1="16" y1="17" x2="8" y2="17"></line>
    <polyline points="10 9 9 9 8 9"></polyline>
  </svg>
</button> */}


      {/* <button 
        className="corporate-summary-squircle" 
        onClick={() => setIsOpen(true)}
      >
         <img src={logoCorporate} className="corporatebtn"/>
       
         <div className="notification-badge">1</div> 
      </button> */}
      <div className="corp-summary-card d-none">
        {/* The Floating T-Curve Image */}
        <img
          src={tiaraCurve}
          alt="Tiara Corporate Summary"
          className="t-curve-image"
        />

        <div className="corp-summary-content">
          {/* <h1 className="iara-title">IARA</h1>
        <p className="corp-summary-label">Corp Summary</p> */}
        </div>
      </div>
      {isOpen && ReactDOM.createPortal(
        <div className="system-wide-overlay" onClick={() => setIsOpen(false)}>
          <div className="system-wide-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-system-view" onClick={() => setIsOpen(false)}>&times;</button>
            <img src={flyerImage} alt="flyer image" className="full-browser-img" />
            <a href={flyerImage} download="Tiara_Flyer_HD.jpg" className="system-download-btn">
              <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" style={{ marginRight: '10px' }}>
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" />
              </svg>
              View & Download
            </a>
          </div>
        </div>,
        document.body
      )}



      <div className="bg-carousel">

        <div className="banner-heading">
          <h1 className="content-basic">
            Software Solutions for CRM, Data Engineering, ERP, Mobile and Web Applications
          </h1>
        </div>
        <div className="carousel" id="banner-slider">

          {bannerSlides.map((slide, index) => (
            <div
              className={`row slider-item ${index === currentIndex ? "active" : ""}`}
              key={index}
              style={{ display: index === currentIndex ? "block" : "none" }}
            >
              <div className="item-render-container">
                <div className="row item-render-area">

                  {/* Left: Text content */}
                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 banner-content-area fw-bold">
                    <div className="content-item-align">
                      <div className={`content-width-flex scalebanner ${slide.menuName?.includes("ERP") ? "erp-width-flex" : ""}`} style={{ padding: "0" }}>
                        <div className={slide.titleClassName}>
                          {slide.title}
                        </div>
                        {slide.renderContent()}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}


        </div>
        {/* <AnnouncementBar /> */}
        <div className="arrows">
          <button id="prev" className="arrow-btn" onClick={() => handleSlideChange("prev")}>
            <FontAwesomeIcon icon={faChevronLeft} className="arrow-icon" />
          </button>
          <button id="next" className="arrow-btn" onClick={() => handleSlideChange("next")}>
            <FontAwesomeIcon icon={faChevronRight} className="arrow-icon" />
          </button>
        </div>



        <div >
          <div className="tile-container">
            <div className="tile-wrapper">
              {bannerSlides.map((slide, index) => (
                <div
                  className={`tile-item ${index === currentIndex ? "active" : ""}`}
                  key={index}
                  onClick={() => handleTileClick(index)}
                >
                  {slide.tileContent}
                </div>
              ))}
            </div>
          </div>

          <Home />
        </div>
      </div>
    </>
  );
};

export default Banner;
